export default "__VITE_ASSET__DmgdqnjM__"